/* NOTE: many of these constants have been duplicated from constants.less */

export const brightNavy = '#19419b';
export const buttonBackgroundColorLight = '#e1e6f2';
export const greyD3 = '#d3d3d3';
export const greyD4 = '#d4d4d4';
export const grey65 = '#656565';
export const metallicBlue = '#54698d';
export const nightBlue = '#061c3f';
export const paleGrey = '#d8dde6';
export const activeGreen = '#0D772D';
export const transparentGrey = (opacity: number) => `rgba(38, 38, 38, ${opacity})`;
export const textBlue = '#19419B';
export const primaryLight = 'rgba(25, 65, 155, 0.13)';
export const linkBlue = '#19419b';
export const statusBlue = '#19419b';
export const backgroundBlue = '#e1e6f2'; // similar color of @statusBlue at 0.13 opacity.
export const statusOrange = '#c23a00';
export const backgroundOrange = '#ffe7db'; // similar color of @statusOrange at 0.13 opacity.
export const statusGrey = '#a7a7a7';
export const backgroundGrey = '#ededed';
export const statusGreen = '#0d772d';
export const backgroundGreen = '#d0edd9'; // similar color of @statusGreen at 0.13 opacity.
export const statusRed = '#c70011';
export const red = '#d0021b';
export const backgroundRed = '#ffd5d8'; // similar color of @statusGreen at 0.13 opacity.
export const orange = '#ff5005';
export const labelGrey = '#262626';
export const selectedBlue = '#1589ee';

export const containerBorder = '1px solid rgba(38, 38, 38, 0.2)';
export const lightBorder = '1px solid rgb(219,219,219)';

// Dimensions
export const formFieldWidth = 318;
export const inputWidth = '270px';
export const navBarWidth = 80;
export const candidateDetailsPageSubSectionPadding = 10;
export const dataCaptureFormFieldWidth = 348;
export const fieldFontSize = '18px';

// Media queries
export const twoColumnFieldsPageMinWidth = `${
	formFieldWidth * 2 + navBarWidth + 50 + candidateDetailsPageSubSectionPadding * 2
}px`;

export const dataCaptureTwoColumnFieldsPageMinWidth =
	dataCaptureFormFieldWidth * 2 + navBarWidth + 50 + candidateDetailsPageSubSectionPadding * 2;

export const dataCaptureOneColumnFieldsPageMaxWidth = dataCaptureTwoColumnFieldsPageMinWidth - 1;

// borders
export const grey26WithAlpha = 'rgba(38, 38, 38, 0.65)';
export const fieldBorder = '1px solid rgba(38, 38, 38, 0.3)';
export const grey26 = '#262626';
export const horizontalLineBorder = '1px solid #d4d4d4';
export const thickHorizontalLineBorder = '2px solid #d4d4d4';
export const blueyGrey = '#a8b7c7';

// Colours for Data capture page
export const fieldBackgroundWhite = '#f8f7f3';

export const sofiaFontBold = 700;

export const dynamicFormsWidth = '780px';
export const dynamicFormsInnerWidth = '726px';

export const oldFieldHeight = '32px';
export const dataCaptureFieldHeight = '38px';

// Media queries
export const phoneOnlyMaxWidth = '599px';

export const tabletPortraitMaxWidth = '899px';

export const fieldHorizontalMargin = '15px';

/* z-indexes */
export const mobilePhoneSelectZIndex = 1; // Should be the same as @mobilePhoneSelectZIndex in constants.less.
export const overlayZIndex = mobilePhoneSelectZIndex + 1;
export const candidateActionButtonZIndex = overlayZIndex + 1;
export const actionListZIndex = candidateActionButtonZIndex + 1;
